import React from 'react';
import { Star } from 'lucide-react';

/**
 * Interactive 1-5 star rating.
 * Props:
 * - value: current rating (0-5). 0 = no rating.
 * - onChange(newValue): called when user clicks a star. Omit for read-only.
 * - size: pixel size of each star (default 22)
 * - readonly: boolean; if true no click handler, no hover state.
 * - testIdPrefix: base data-testid; each star gets `${prefix}-${n}`
 */
export default function StarRating({ value = 0, onChange, size = 22, readonly = false, testIdPrefix = 'star' }) {
  const [hover, setHover] = React.useState(0);
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="inline-flex items-center gap-0.5 select-none">
      {stars.map((n) => {
        const active = (hover || value) >= n;
        return (
          <button
            key={n}
            type="button"
            disabled={readonly}
            onMouseEnter={() => !readonly && setHover(n)}
            onMouseLeave={() => !readonly && setHover(0)}
            onClick={() => !readonly && onChange && onChange(n)}
            data-testid={`${testIdPrefix}-${n}`}
            className={`transition-transform ${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'}`}
          >
            <Star
              size={size}
              fill={active ? '#f59e0b' : 'transparent'}
              className={active ? 'text-amber-500' : 'text-slate-300'}
              strokeWidth={2}
            />
          </button>
        );
      })}
    </div>
  );
}
